var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.padding ? 'pa-3' : ''},[_c('v-img',{attrs:{"src":_vm.imageSrc,"contain":"","eager":_vm.eager}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }